import { useEffect, useState } from "react"
import Exp from "./assests/Experience.png"
import Sebi from "./assests/sbi.png"
import Advisor from "./assests/About/advisor.jpg"

const AboutSection = () => {
  const [advisorText, setAdvisorText] = useState("advisor")

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_ADVISOR_SPECIFIER === "RA") {
      setAdvisorText("Research Analyst")
    }
  }, [])

  return (
    <div className="flex flex-col lg:flex-row bg-white py-8 md:py-16" id="aboutSection">
      {/* Image Column */}
      <div className="w-full lg:w-2/5 px-4 md:px-8 lg:px-12 mb-8 lg:mb-0">
        <div className="relative h-0 pb-[125%] overflow-hidden">
          <img
            src={Advisor || "/placeholder.svg"}
            alt="Amit Dhamija"
            className="absolute inset-0 w-full h-full object-contain hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>

      {/* Content Column */}
      <div className="flex flex-col justify-center w-full lg:w-3/5 px-6 md:px-12 lg:px-16">
        <div className="w-full max-w-3xl mx-auto lg:mx-0">
          <div className="flex justify-center lg:justify-start">
            <span className="inline-block px-4 py-1 bg-blue-50 text-blue-600 font-semibold text-sm rounded-full mb-4">
              ABOUT RA
            </span>
          </div>

          <h2 className="font-Montserrat text-gray-900 font-bold text-3xl sm:text-4xl md:text-5xl text-center lg:text-left leading-tight mb-4">
            Amit Dhamija
          </h2>

          <p className="font-poppins font-normal text-base md:text-lg text-gray-600 text-center lg:text-left leading-relaxed mb-8">
            Amit Dhamija is a seasoned investor and systematic trader with almost 3 decades of experience. As a
            SEBI-registered Research Analyst, he has empowered thousands of individuals through his data-driven,
            statistical approach to trade & invest in stocks & index derivatives. With an unwavering passion for the
            markets and a strong academic foundation—holding degrees in Company Secretary (CS), LLM, MBA (Finance), PGD
            in IPR, and having completed the Leadership Program at IIM Bangalore—Amit has built a distinguished career
            in the financial industry. He currently serves as CEO of Market Analysis Academy.
          </p>

          {/* Experience and SEBI Registration Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
            <div className="flex items-center space-x-4 bg-white p-4 md:p-5 rounded-xl shadow-sm border border-gray-100">
              <div className="bg-blue-50 p-2 md:p-3 rounded-full flex-shrink-0">
                <img src={Exp || "/placeholder.svg"} alt="Experience Logo" className="w-8 h-8 md:w-10 md:h-10" />
              </div>
              <div className="flex flex-col">
                <div className="text-base md:text-lg lg:text-xl font-bold leading-tight tracking-tight text-gray-900">
                  30 years of experience
                </div>
                <div className="text-xs md:text-sm lg:text-base leading-snug text-gray-500 font-medium">
                  Years of Experience
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4 bg-white p-4 md:p-5 rounded-xl shadow-sm border border-gray-100">
              <div className="bg-blue-50 p-2 md:p-3 rounded-full flex-shrink-0">
                <img src={Sebi || "/placeholder.svg"} alt="SEBI Logo" className="w-8 h-8 md:w-10 md:h-10" />
              </div>
              <div className="flex flex-col">
                <div className="text-base md:text-lg lg:text-xl font-bold leading-tight tracking-tight text-gray-900">
                  INH000019804
                </div>
                <div className="text-xs md:text-sm lg:text-base leading-snug text-gray-500 font-medium">
                  SEBI Registration No.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutSection
